module.exports = __webpack_public_path__ + "img/pingyuanxinquAppImage.97405873.png";